


export const GetPageTitle = () => {
    const path = window.location.pathname;
  
    if (path === '/profile-setting') return 'Profile';
    if (path === '/notification') return 'Notifications';

    
    if (path === '/') return 'Policy & Compliance Auditor';

    return 'Default Title';
  };
  

  
  